import React, {
    useContext, useCallback, useEffect, useState
} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { CurrencyField, ModalNextProvider } from '@jutro/components'
import { TranslatorContext } from '@jutro/locale';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { isCapabilityEnabled } from 'gw-portals-config-js';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import message from '../../../PolicyChangeCommon.messages';
import styles from './PaymentPage.module.scss';
import metadata from './PaymentPage.metadata.json5';
import messages from '../PaymentPage.messages';

const { capabilitiesConfig } = appConfig;

function PaymentPage(props) {
    const {
        wizardData,
        updateWizardData,
        history,
        createUWActivity
    } = props;
    const { authHeader, checkPermission } = useAuthentication();
    const translator = useContext(TranslatorContext)
    const { EndorsementService } = useDependencies('EndorsementService');
    const { BillingService } = useDependencies('BillingService');
    const { submissionVM } = wizardData;
    const [showPremiumDecrease, setShowPremiumDecrease] = useState(false);
    const [paymentDifferenceCost, setPaymentDifferenceCost] = useState(0);
    const [unpaidInvoicesExist, updateUnpaidInvoicesExist] = useState(false);
    const { isComponentValid, initialValidation } = useValidation('PAPolicyChangePaymentPage');


    useEffect(() => {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
            BillingService.getPolicyBillingSummary(submissionVM.value.policyNumber, authHeader)
                .then((policyBillingSummary) => {
                    if (
                        policyBillingSummary.unpaidInvoices
                        && policyBillingSummary.unpaidInvoices.length > 0
                    ) {
                        updateUnpaidInvoicesExist(true);
                    }
                })
                .catch((err) => {
                    console.error('Error checking policy details', err);
                });
        }
    }, []);

    useEffect(() => {
        if (!_.isEmpty(submissionVM)) {
            const transactionAmount = _.get(submissionVM, 'transactionCost.amount.value');
            setPaymentDifferenceCost(transactionAmount);
            if (transactionAmount <= 0) {
                _.set(wizardData, 'paymentsDataVM', []);
                setShowPremiumDecrease(true);
            }
        }
    }, [setShowPremiumDecrease, submissionVM, wizardData]);


    const onNext = useCallback(async () => {    
        try{
            const brokerDecPopUp = await ModalNextProvider.showConfirm({
                title: messages.brokerDeclaration,
                message: messages.confirmationOfSignAndDoc,
                status: 'success',
                icon: 'mi-error-outline',
                confirmButtonText: messages.ok,
                cancelButtonText: messages.cancel
            });
            if (brokerDecPopUp === 'cancel') {
                return false;
            }
            const result = await ModalNextProvider.showConfirm({
                title: messages.issuePolicy,
                message: translator(messages.confirmationNote),
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.confirmYes,
                cancelButtonText: messages.confirmNo
            });
            if (result === 'cancel') {
                return false;
            }
            try {
                let paymentDetails = {
                    paymentMethod: 'redistribute',
                    specialHandeling_EY: submissionVM.value.paymentDetails['specialHandeling_EY']
                };
                if(createUWActivity){
                    await EndorsementService.createUWActivity([submissionVM.value.jobID], authHeader);
                }
                const bindResponse = await EndorsementService.bind(
                    [submissionVM.value.jobID, paymentDetails],
                    authHeader
                );
                submissionVM.value = bindResponse.policyChange;
                _.set(wizardData, 'changesAppliedForward', bindResponse.changesAppliedForward);
                _.set(wizardData, 'canApplyChangesToFutureRenewal_EY', bindResponse.canApplyChangesToFutureRenewal_EY);
                _.set(wizardData, 'canApplyChangesToFutureUnboundRenewal_EY', bindResponse.canApplyChangesToFutureUnboundRenewal_EY);
                updateWizardData(wizardData);        
            
            } catch {
                const policyNumber = _.get(submissionVM, 'policyNumber.value');
                history.push(`/contactAgent/${policyNumber}`);
            }
            return wizardData;
        } catch(ex) {
            return false
        }                     
    }, [
        EndorsementService,
        authHeader,
        history,
        submissionVM,
        updateWizardData,
        wizardData
    ]);

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: 'left',
            showRequired: true
        },
        policyChange: {
            visible: paymentDifferenceCost > 0
        },
        policyChangePaymentsDecreaseInPremium: {
            visible: showPremiumDecrease
        },
        policyPeriod: {
            labelPosition: undefined
        },
        policySchedulesTable: {
            data: submissionVM ? submissionVM.paymentPlans_EY.value.map((m) => { m['id'] = m.billingId; return m; }) : []
        }
    };

    const handleValueChange = (value, path) => {
        console.log(value);
    }

    const getDataTableCell = (item, index, props) => {
        return (
            <CurrencyField
                id={`currency_${index}`}
                value={item[props.path]}
                readOnly={true}
                hideLabel={true}
            />
        )
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getDataTableCell: getDataTableCell,
            handleValueChange: handleValueChange
        }
    };

    return (
        <WizardPage
            nextLabel={messages.issuePolicyChange}
            showNext={checkPermission('issue')}
            cancelLabel={(appConfig.persona === 'policyholder' ? message.cancelAllChanges : message.cancel)}
            skipWhen={initialValidation}
            disableNext={!isComponentValid}
            onNext={onNext}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

PaymentPage.propTypes = wizardProps;
export const PaymentPageComponent = PaymentPage;
export default withRouter(PaymentPage);
